import { createContext, useContext } from "react";

interface ThemeModeContextValue {
  isDarkMode: boolean;
  toggleThemeMode: () => void;
}

export const ThemeModeContext = createContext<
  ThemeModeContextValue | undefined
>(undefined);

export const useThemeMode = (): ThemeModeContextValue => {
  const context = useContext(ThemeModeContext);

  if (!context) {
    throw new Error("Theme mode context is not available.");
  }

  return context;
};
